import Observer from 'app/services/core/Observer.service'

export const PAGE_CHANGE = 'PAGE_CHANGE'
export const PAGE_CHANGED = 'PAGE_CHANGED'
export const PAGE_INFO_CHANGE = 'PAGE_INFO_CHANGE'
export const PAGE_TYPE_CHANGE = 'PAGE_TYPE_CHANGE'
export const PAGE_AUDIO_ENDED = 'PAGE_AUDIO_ENDED'
export const PAGE_AUDIO_STOP = 'PAGE_AUDIO_STOP'

export default new Observer()
